import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { LoaderButton } from '../../../component/button';
import { InputWithIcon } from '../../../component/input';
import { pxToRem } from '../../../utils/pxToRem';

export const ResetWraper = styled.main<{ error?: boolean }>`
  background-color: #ffffff;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(100vh - 75px);
  padding: 40px 120px;

  @media screen and (max-width: 1000px) {
    padding: 40px 80px;
  }
  @media screen and (max-width: 550px) {
    padding: 40px 40px;
  }
  @media screen and (max-width: 450px) {
    padding: 40px 20px;
  }
`;
export const LogoWrapper = styled.div<{ error?: boolean }>`
  @media screen and (max-width: 550px) {
  }
`;
export const LogoImage = styled.img<{ error?: boolean }>`
  width: 60px;
  height: 32px;
`;
export const ResetContainer = styled.div<{ error?: boolean }>`
  margin: auto;
  width: 504px;

  @media screen and (max-width: 650px) {
    width: 100%;
  }
`;

export const FormBox = styled.form<{ error?: boolean }>`
  text-align: center;
`;
export const TitleSection = styled.div<{ error?: boolean }>``;
export const ResetTitle = styled.h4<{ error?: boolean }>`
  font-weight: 700;
  font-size: ${pxToRem(32)};
  line-height: ${pxToRem(48)};
  color: #030309;

  @media screen and (max-width: 500px) {
    font-size: ${pxToRem(23)};
  }
`;

export const ResetPhrase = styled.div`
  font-weight: 700;
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(24)};
  color: #57575b;
  margin-top: 16px;

  @media screen and (max-width: 500px) {
    font-size: ${pxToRem(11.513)};
    margin-top: 5px;
  }
`;

export const InputContainer = styled(InputWithIcon)`
  width: calc(100%);
  border-radius: 5px;
  padding: 8px;
`;

export const ResetInput = styled.input<{ error?: boolean }>`
  width: calc(100%);
  border: none;
  outline: none;
  padding: 8px;
  background-color: #fafafa;

  &::placeholder {
    font-weight: 700;
    font-size: ${pxToRem(15)};
    line-height: ${pxToRem(24)};
    color: rgba(9, 14, 17, 0.2);
  }
`;
export const ResetButton = styled(LoaderButton)`
  width: 70%;
  margin: auto;
  margin-top: 18px;
`;

export const RememberPassword = styled.p`
  font-weight: 700;
  font-size: ${pxToRem(15)};
  line-height: ${pxToRem(24)};
  color: rgba(15, 14, 45, 0.5);
  margin-top: 35px;
`;
export const SigninLink = styled(Link)`
  color: #fda800;
  text-decoration: none;
  cursor: pointer;
`;
